type AreObjectsEqualProps = {
    firstObject: Record<string, unknown>;
    secondObject: Record<string, unknown>;
};

const areObjectsEqual = ({ firstObject, secondObject }: AreObjectsEqualProps): boolean => {
    const firstObjectKeys = Object.keys(firstObject);
    const secondObjectKeys = Object.keys(secondObject);

    const objectsContainTheSameNumberOfKeys = firstObjectKeys.length === secondObjectKeys.length;

    if (!objectsContainTheSameNumberOfKeys) {
        return false;
    }

    return firstObjectKeys.every((key) => key in secondObject && firstObject[key] === secondObject[key]);
};

export default areObjectsEqual;
